import withReactContent from 'sweetalert2-react-content'
import './LessonPlanCard.scss'
import Swal from 'sweetalert2'
import LessonPlanForm from '../LessonPlanForm/LessonPlanForm'
import LessonPlansService from '../../../../services/lessonPlans.service'

const LessonPlanCard = ({
  lessonPlan,
  book,
  setLoadedLessonPlans,
  setLoadedBook
}) => {
  const MySwal = withReactContent(Swal)

  function handleUpdateLessonPlanModal() {
    MySwal.fire({
      showCancelButton: false,
      showConfirmButton: false,
      showCloseButton: true,
      title: <span style={{ color: '#FFC107' }}>Editar Plano de Aula</span>,
      html: (
        <LessonPlanForm
          lessonPlan={lessonPlan}
          book={book}
          setLoadedBook={setLoadedBook}
          setLoadedLessonPlans={setLoadedLessonPlans}
        />
      )
    })
  }

  function handleDeleteLessonPlanModal() {
    MySwal.fire({
      showCancelButton: true,
      confirmButtonColor: '#E81E47',
      cancelButtonColor: '#fff',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      icon: 'warning',
      title: (
        <span style={{ color: '#FFC107' }}>
          Deseja excluir o plano de aula?
        </span>
      ),
      html: <p style={{ color: '#000' }}>Será ação não poderá ser revertida.</p>
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleDeleteLessonPlan()
      } else {
        Swal.close()
      }
    })
  }

  async function handleDeleteLessonPlan() {
    try {
      await LessonPlansService.delete(lessonPlan.id)

      MySwal.fire({
        confirmButtonColor: '#87BF40',
        confirmButtonText: <span>Ok</span>,
        icon: 'success',
        title: (
          <span style={{ color: '#FFC107' }}>
            Plano de aula deletado com sucesso!
          </span>
        )
      }).then(() => {
        setLoadedLessonPlans((prev) =>
          prev.filter((lesson) => lesson.id !== lessonPlan.id)
        )
        setLoadedBook((prev) => ({
          ...prev,
          lessonPlans: prev.lessonPlans.filter(
            (lesson) => lesson.id !== lessonPlan.id
          )
        }))
      })
    } catch (error) {
      console.error(error)
      MySwal.fire({
        confirmButtonColor: '#87BF40',
        confirmButtonText: <span>Voltar</span>,
        icon: 'error',
        title: (
          <span style={{ color: '#FFC107' }}>
            Não foi possível deletar o plano de aula!
          </span>
        )
      })
    }
  }

  return (
    <div className='lesson-plan-card-container'>
      <div className='lesson-plan-card-header'>
        <h5>{`Capítulo ${lessonPlan.chapter}`}</h5>
        <div className='lesson-plan-card-actions'>
          <button
            className='lesson-plan-card-edit-button'
            title='Editar plano de aula'
            onClick={handleUpdateLessonPlanModal}
          >
            <i className='fa fa-pen'></i>
          </button>
          <button
            className='lesson-plan-card-delete-button'
            title='Excluir plano de aula'
            onClick={handleDeleteLessonPlanModal}
          >
            <i className='fa fa-trash'></i>
          </button>
        </div>
      </div>
      {(lessonPlan.presentationLink || lessonPlan.videoLink) && (
        <div className='lesson-plan-card-links'>
          {lessonPlan.presentationLink && (
            <a
              href={lessonPlan.presentationLink}
              target='_blank'
              rel='noreferrer'
              className='button-full'
            >
              Acessar apresentação
            </a>
          )}
          {lessonPlan.videoLink && (
            <a
              href={lessonPlan.videoLink}
              target='_blank'
              rel='noreferrer'
              className='button-full'
            >
              Acessar vídeo
            </a>
          )}
        </div>
      )}
    </div>
  )
}

export default LessonPlanCard
